module.exports = __webpack_public_path__ + "img/zhongshiyou.d5845027.png";